/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Enter_Tracking_NumberInputs */

const en_orders_enter_tracking_number = /** @type {(inputs: Orders_Enter_Tracking_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter tracking number`)
};

const es_orders_enter_tracking_number = /** @type {(inputs: Orders_Enter_Tracking_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa numero de tracking`)
};

/**
* | output |
* | --- |
* | "Enter tracking number" |
*
* @param {Orders_Enter_Tracking_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_enter_tracking_number = /** @type {((inputs?: Orders_Enter_Tracking_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Enter_Tracking_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_enter_tracking_number(inputs)
	return es_orders_enter_tracking_number(inputs)
});